import { render } from "./files-carousel.vue?vue&type=template&id=33654bca"
import script from "./files-carousel.vue?vue&type=script&lang=js"
export * from "./files-carousel.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__